"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var I18n = require("i18n-js");
var refund_request_1 = require("./refund_request");
var RefundRequestReason = function (props) {
    if (props.userType !== refund_request_1.IUserType.BUYER && props.refundRequest.isPersisted) {
        return null;
    }
    function renderOptions() {
        var options = [React.createElement("option", { value: "", key: "prompt" }, I18n.t('discovery.dashboard.refundRequests.selectOne'))];
        props.reasons.forEach(function (reason) {
            var text = I18n.t("discovery.dashboard.refundRequests." + props.userType + ".reasons." + reason);
            options.push(React.createElement("option", { value: reason, key: reason }, text));
        });
        return options;
    }
    return (React.createElement("div", { className: "form-group" },
        React.createElement("div", { className: "form-group__header" },
            React.createElement("label", { className: "form-group__label-text", htmlFor: "order_refund_request_reason" }, I18n.t('discovery.dashboard.refundRequests.reason')),
            React.createElement("div", { className: "form-group__tag" }, I18n.t('discovery.dashboard.refundRequests.required'))),
        React.createElement("div", { className: "form-group__fields" },
            React.createElement("div", { className: "styled-dropdown" },
                React.createElement("select", { id: "order_refund_request_reason", name: "order_refund_request[reason]", onChange: props.onRefundReasonChange, required: true, className: "nochosen", "data-refund-reason-select": true }, renderOptions())))));
};
exports.default = RefundRequestReason;
//# sourceMappingURL=refund_request_reason.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/refund_requests/refund_request_reason.js
// module id = agNW
// module chunks = 20 21